import { Navigate, useSearchParams } from 'react-router-dom';
import { RegisterForm } from '@/components/auth/RegisterForm';
import { SimpleRegisterForm } from '@/components/auth/SimpleRegisterForm';
import { useAuth } from '@/hooks/useAuth';

export const RegisterPage = () => {
  const { isAuthenticated } = useAuth();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode'); // 'simple' | 'full'

  // 既にログイン済みの場合はダッシュボードにリダイレクト
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  // モードに応じてフォームを切り替え（デフォルトは簡易版）
  const showFullForm = mode === 'full';

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-primary-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-soft p-8">
          {showFullForm ? <RegisterForm /> : <SimpleRegisterForm />}
        </div>
      </div>
    </div>
  );
};